<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :state="getValidationState(validatable, validationContext)"
      :label-cols-sm="noLabel ? undefined : labelColsSm"
      :class="controlClass"
      :label-class="labelClass"
    >
      <template slot="label">
        <div>
          {{ noLabel ? undefined : fieldLabel }}
          <base-help-icon :help-description="helpDescription" />
        </div>
      </template>
      <multiselect
        :value="preparedValue"
        v-bind="settings"
        @input="emitValue"
      />
      <b-form-invalid-feedback
        v-if="validatable"
        :state="getValidationState(validatable, validationContext)"
      >
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Multiselect from "vue-multiselect";
import { baseValidatableMixin } from "@foys-tech/foys-utils";
import { BaseHelpIcon } from "./";
export default {
  mixins: [baseValidatableMixin],
  components: { Multiselect, BaseHelpIcon },
  props: {
    /**
     * Multiselect props
     * https://vue-multiselect.js.org/#sub-props
     */
    settings: {
      type: Object,
      default: () => {},
    },
    valueField: {
      type: String,
      default: null,
    },
  },
  computed: {
    preparedValue() {
      if (!this.valueField || !this.value) {
        return this.value;
      }

      if (this.settings.multiple) {
        return this.settings.options.filter(
          (e) => this.value.indexOf(e[this.valueField]) > -1
        );
      } else {
        return this.settings.options.find(
          (e) => this.value == e[this.valueField]
        );
      }
    },
  },
  methods: {
    processInput($event) {
      if (this.settings.multiple) {
        return this.valueField ? $event.map((e) => e[this.valueField]) : $event;
      } else {
        return this.valueField ? $event[this.valueField] : $event;
      }
    },
  },
};
</script>